import { createBrowserRouter } from 'react-router';
import { appRoutes } from './routes';

export const router = createBrowserRouter(appRoutes);
